import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { LocationFilterEnum } from 'enums/global.enum';
import AppAccordion from 'shared/design-system/components/app-accordion';
import AppCard from 'shared/design-system/components/app-card';
import NoData from 'shared/design-system/components/no-data-box';
import LinksButton from 'shared/design-system/components/links-button';
import useFormClOrders from 'shared/design-system/components/app-accordion/_hooks/useFormClOrders';
import useGetAndMapClOrders from './_hooks/useGetAndMapClOrders';
import useGetClOrderOptions from './_hooks/useGetClOrderOptions';
import FiltersClOrders, { clOrderListFormData } from './_components/filters-cl-orders';
import AddClOrderModal from './_components/add-cl-order-modal';
import ClOrderListTable from './_components/cl-order-list-table';
import ServerSidePaginator from 'shared/design-system/components/app-server-side-paginator';
import { useAppDispatch, useAppSelector } from 'core/store/hooks';
import { searchClOrders } from '../_redux/actions';
import { filtersClOrdersUsedSelector } from '../_redux/selectors';

const ClOrdersList: React.FC = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const filterUsed = useAppSelector(filtersClOrdersUsedSelector);
  const { orders, paginatorData } = useGetAndMapClOrders();
  const { mappedClOrderOptions } = useGetClOrderOptions();
  const [showAddOrderModal, setShowAddOrderModal] = useState<boolean>(false);

  const [isOpen, setIsOpen] = useState<boolean>(true);
  const { onSubmit, onReset, chipsFormData, setChipsFormData, reset } = useFormClOrders(clOrderListFormData, setIsOpen);

  const [controlledDate, setControlledDate] = useState<any>(null);

  const handleReset = () => {
    onReset();
    controlledDate && setControlledDate([]);
    chipsFormData && setChipsFormData([]);
  };

  const changePage = (page: number) => {
    let filters = { ...filterUsed };
    if (filters.paging) {
      filters.paging = { ...filters.paging, page: page };
    }
    dispatch(searchClOrders({ searchDto: filters }));
  };

  return (
    <>
      <div className="d-flex justify-content-between mt-3">
        <h4 className="text-gray-800 my-0">{t('cl-orders.title')}</h4>
        <div>
          <LinksButton className="btn-sm btn-primary btn-teal px-4 ms-auto" onClick={() => setShowAddOrderModal(true)}>
            {t('cl-orders.add-order')}
          </LinksButton>
        </div>
      </div>

      <AppAccordion
        formData={clOrderListFormData}
        location={LocationFilterEnum.CL_ORDERS}
        setIsOpen={setIsOpen}
        isOpen={isOpen}
        chipsFormData={chipsFormData}
        setChipsFormData={setChipsFormData}
        reset={reset}
      >
        <FiltersClOrders
          onSubmit={onSubmit}
          handleReset={handleReset}
          setControlledDate={setControlledDate}
          mappedClOrderOptions={mappedClOrderOptions}
        />
      </AppAccordion>

      <AppCard title={t('cl-orders.all-orders')} className="mt-3">
        {orders.length === 0 ? (
          <NoData msg={t('cl-orders.no-orders')} />
        ) : (
          <>
            <ClOrderListTable data={orders} />
          </>
        )}
        {orders?.length > 0 ? (
          <ServerSidePaginator
            currentPage={paginatorData?.page || 0}
            totalPages={paginatorData?.totalPages || 0}
            elementsToShow={orders.length}
            totalElements={paginatorData?.totalElements}
            onPageChange={(e) => changePage(e)}
          />
        ) : (
          ''
        )}
      </AppCard>
      <AddClOrderModal
        show={showAddOrderModal}
        setShow={setShowAddOrderModal}
        mappedClOrderOptions={mappedClOrderOptions}
      />
    </>
  );
};

export default ClOrdersList;
